/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'HR.com - The Human Resources Social Network',
    SITE_DESCRIPTION:
      'HR.com is the largest community for HR professionals featuring articles, news, webcasts, events, white papers, discussion forums, templates, forms and best practices on leadership, performance management, organizational development, and benefits.',
    OG_IMAGE: '/static/hrcom/logo.png',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/hrdotcom/',
      twitter: ' https://twitter.com/hrdotcom',
      linkedin: 'https://www.linkedin.com/company/hrdotcom',
      instagram: 'https://www.instagram.com/hrdotcom/',
      youtube: ' https://www.youtube.com/c/hrcom',
    },
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-96HH2FQJVE'],
    ASSETS: {
      logo: '/static/hrcom/logo.png',
      loginImage: '/static/hrcom/hr_com_login.png',
      faviconsPath: '/static/hrcom',
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#2A5A8D',
      },
    },
  },
});
